export default __webpack_public_path__ + "static/media/section2_7.cbe7052e.png";